import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ConnectionAuthModel, ConnectionAuthProvider } from '@libs/shared/models';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  public constructor(
    private readonly authProvider: ConnectionAuthProvider,
    private readonly authService: AuthService,
    private readonly router: Router) {
  }

  public async canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const auth: ConnectionAuthModel = await firstValueFrom(this.authProvider.getAuth());
    // for this guard we only need to verify if the azure token is present.
    // otherwise the app will redirect to /auth

    if (auth.token?.type === 'llDirectoryUser' && !auth.token.userId) {
      return this.router.createUrlTree(['/agent']);
    }

    if (auth.token) {
      return true;
    }

    if (state.url.endsWith('home') || state.url.endsWith('logout')) {
      return this.router.createUrlTree(['/auth']);
    }

    await this.router.navigate(['/auth'], {
      queryParams: { returnUrl: state.url },
    });

    await firstValueFrom(this.authService.login());

    return false;
  }
}
